import { describeError, isAppError } from '@kdk/shared';
import { Alert, Button } from '@mui/material';
import { useLocation, useNavigate, useRouteError } from 'react-router';

/** ルート単位の Error Boundary。ページが落ちてもサイドバーは残る。 */
export const PageError = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return (
    <Alert
      severity="error"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            // 同じ URL へ置き換え遷移する。location が変わるとエラーバウンダリがリセットされ、
            // ページ全体を再読み込みせずに(サイドバーなどの状態を保ったまま)もう一度描画を試みる
            void navigate(`${pathname}${search}`, { replace: true });
          }}
        >
          再読み込み
        </Button>
      }
    >
      このページでエラーが発生しました。{isAppError(error) ? describeError(error) : ''}
    </Alert>
  );
};
